import {
  CLEAR_VOICE_TEST,
  FETCH_VOICE_TEST_OVERVIEW_SUCCESS,
  CLEAR_VOICE_TEST_CANDIDATES,
  FETCH_VOICE_TEST_CANDIDATES_SUCCESS,
  FETCH_VOICE_TEST_SKILLVENDORS_BY_CRITERIA_SUCCESS,
  CLEAR_VOICE_TEST_SKILLVENDORS_BY_CRITERIA
} from '../../../actions/pages/voice-test-page'

export function voiceTestPage (
  state = {
    overview: null,
    candidates: null,
    skillVendorsByCriteria: []
  },
  action
) {
  switch (action.type) {
    case CLEAR_VOICE_TEST: {
      return Object.assign({}, state, {
        overview: null,
        candidates: null,
        skillVendorsByCriteria: []
      })
    }
    case FETCH_VOICE_TEST_OVERVIEW_SUCCESS: {
      return Object.assign({}, state, {
        overview: action.overview
      })
    }
    case CLEAR_VOICE_TEST_CANDIDATES: {
      return Object.assign({}, state, {
        candidates: null
      })
    }
    case FETCH_VOICE_TEST_CANDIDATES_SUCCESS: {
      return Object.assign({}, state, {
        candidates: action.candidates
      })
    }
    case FETCH_VOICE_TEST_SKILLVENDORS_BY_CRITERIA_SUCCESS: {
      return Object.assign({}, state, {
        skillVendorsByCriteria: action.skillVendorsByCriteria
      })
    }
    case CLEAR_VOICE_TEST_SKILLVENDORS_BY_CRITERIA: {
      return Object.assign({}, state, {
        skillVendorsByCriteria: []
      })
    }
    default:
      return state
  }
}
